(function($) {
    $.fn.doAddressLookup = function(checkPostcodeLink, callback, opts) {
        var _this = this;

        _this.options = {
            messageElementSelector: '[data-js-address-message]',
            errorMessage: 'No addresses could be found for this postcode.',
            addressInputName: 'address',
            cityInputName: 'city',
            countryInputName: 'country',
            districtInputName: 'district',
            countyInputName: 'county',
            postCodeInputName: 'postcode',
        };

        _this.options = $.extend({}, _this.options, opts);
        _this.messageElement = _this.find(_this.options.messageElementSelector);
        _this.callback = callback;
        _this.checkPostcodeLink = checkPostcodeLink;
        // Remove any existing event listeners before adding new ones
        document.removeEventListener("getaddress-find-suggestions", handleSuggestions);
        document.removeEventListener("getaddress-find-address-selected", handleAddressSelection);

        // Add new listener
        document.addEventListener("getaddress-find-suggestions", handleSuggestions);
        document.addEventListener("getaddress-find-suggestions-failed", function(e) {
            console.error('Lookup failed:', e.status, e.message);
        });
        document.addEventListener("getaddress-find-address-selected", handleAddressSelection);
        // _this.handleSuggestions = function(e) {
        
        function handleSuggestions(e) {
            if (e.suggestions.length === 0) {
                _this.messageElement.html(_this.options.errorMessage);
                $('.find-dropdown').addClass('display-none');
                _this.emptyAllFormInputs();
            } else {
                _this.messageElement.empty();
                $('.find-dropdown').removeClass('display-none');
                $('.find-dropdown').on('click', function (event) {
                    event.preventDefault();
                    event.stopPropagation();
                });
            }
        }
        function handleAddressSelection(e) {
            _this.setAddressToFormInputs(e.address);
        }
        _this.emptyAllFormInputs = function() {
            _this.find('input[data-address]').each(function() {
                $(this).val('').next('label').removeClass('active');
            });
        };

        _this.setAddressToFormInputs = function(address) {
            const addressArr = [address.line_1, address.line_2, address.line_3].filter(o => o && typeof o === 'string' && o !== '');
            _this.find('input[data-address="' + _this.options.addressInputName + '"]').val(addressArr.join(', ')).next('label').addClass('active');
            _this.find('input[data-address="' + _this.options.cityInputName + '"]').val(address.town_or_city).next('label').addClass('active');
            _this.find('input[data-address="' + _this.options.countryInputName + '"]').val(address.country).next('label').addClass('active');
            _this.find('input[data-address="' + _this.options.districtInputName + '"]').val(address.district).next('label').addClass('active');
            _this.find('input[data-address="' + _this.options.countyInputName + '"]').val(address.county).next('label').addClass('active');
            _this.find('input[data-address="' + _this.options.postCodeInputName + '"]').val(address.postcode).next('label').addClass('active');

            _this.doInternalRequestToCreatePostcodeIfNotExists(address);

            if (typeof _this.callback === 'function') {
                _this.callback.call(_this);
            }
        };

        _this.doInternalRequestToCreatePostcodeIfNotExists = function(address) {
            $.ajax({
                type: 'POST',
                url: _this.checkPostcodeLink,
                data: {
                    postcode: address.postcode,
                    latitude: address.latitude,
                    longitude: address.longitude
                }
            });
        };

        return _this;
    };
})(jQuery);
